<template>
    <div class="password-form p-4 mt-4">
        <div class="row p-2">
            <div class="col-1">
                <i class="fa fa-database"></i>
            </div>
            <div class="col-10 text-center">
                <h5>Actualizar información</h5>
                <small v-if="entity">{{entity.name}}</small>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="password" class="text-center" ref="password">Nombre: </label>
                    <input v-validate="''" name="name" data-vv-as="nombre" type="text" class="form-control" id="name" v-model="entity.name">
                    <span class="validation-error">{{errors.first('name')}}</span>
                </div>
                <div class="form-group">
                    <label for="password" class="text-center" ref="password">Correo: </label>
                    <input v-validate="'email'" name="email" data-vv-as="correo" type="text" class="form-control" id="email" v-model="entity.email">
                    <span class="validation-error">{{errors.first('email')}}</span>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="password" class="text-center" ref="password">Contraseña: </label>
                        <input v-validate="'min:8'" name="password" data-vv-as="contraseña" type="password" class="form-control" id="password" ref="password" v-model="entity.password">
                        <span class="validation-error">{{errors.first('password')}}</span>
                    </div>
                    <div class="form-group col-md-6">
                        <label  for="password_confirmation" class="text-center">Confirmación de contraseña: </label>
                        <input v-validate="'min:8|confirmed:password'" name="password_confirmation" data-vv-as="confirmación" type="password" class="form-control" id="password_confirmation" v-model="entity.password_confirmation">
                        <span class="validation-error">{{errors.first('password_confirmation')}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="document" class="text-center">NIT o Registro</label>
                        <input v-validate="''" name="document" data-vv-as="NIT o Registro" type="text" class="form-control" id="document" v-model="entity.document">
                        <span class="validation-error">{{errors.first('document')}}</span>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="phone_number" class="text-center">Teléfono: </label>
                        <input v-validate="'min:7'" name="phone_number" data-vv-as="número telefónico" type="number" class="form-control" id="phone_number" v-model="entity.phone_number">
                        <span class="validation-error">{{errors.first('phone_number')}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <label for="name">Domicilio</label>
                    <textarea v-validate="'max:256'" name="address" data-vv-as="domicilio" type="text" class="form-control" placeholder="Dirección de la dependencia" rows="4" v-model="entity.address"></textarea>
                    <span class="validation-error">{{errors.first('address')}}</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 mb-4 mt-3">
                <input class="btn-block btn-primary btn" type="button" value="Actualizar datos" @click.prevent="validate">
            </div>
            <div class="col-6 mb-4 mt-3">
                <input class="btn-block btn-secondary btn" type="button" value="Cancelar" @click.prevent="$router.back()">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'passwords',
    data(){
        return {
            user: JSON.parse(localStorage.getItem("user")),
            token: localStorage.getItem('session_id'),
            apiURL: process.env.VUE_APP_API,
        }
    },
    props: {
        entity: {
            type: Object,
            required: false
        }
    },
    computed: {
        changePasswordUrl: function()
        {
            return `${this.apiURL}/${this.user.type}/entities/${this.entity.id}`;
        }
    },
    methods: {
        changePassword: function(){
            if(this.entity.id == 0){
                this.$dialogs.alert("Debe seleccionar una dependencia primero");
                return;
            }

            let loader = this.$loading.show();
            this.$http.put(
                this.changePasswordUrl, 
                this.entity,
                {headers: {Authorization: `Bearer ${this.token}`}})
                .then(data => {
                    loader.hide();
                    this.$dialogs.alert(`Se ha actualizado la dependencia ${this.entity.name} de forma exitosa`, {title: "Éxito", size: "sm"});
                    this.$router.back();
                })
                .catch(error => {
                    console.log(error);
                    this.$router.back();
                })
              
        }, 
        validate: function(){
            this.$validator
            .validate()
            .then(valid => {
                if(valid){
                    this.changePassword();
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    .password-form {
        border-radius: 5px;
        box-shadow: 0px 0px 5px lightgray;
    }

    .validation-error {
        font-size: 14px;
        color: red;
    }
</style>
